export default "__VITE_ASSET__$MSj5lwb__"